import { render, staticRenderFns } from "./ReServiceCharts.vue?vue&type=template&id=60672076&scoped=true"
import script from "./ReServiceCharts.vue?vue&type=script&lang=js"
export * from "./ReServiceCharts.vue?vue&type=script&lang=js"
import style0 from "./ReServiceCharts.vue?vue&type=style&index=0&id=60672076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60672076",
  null
  
)

export default component.exports